import React from "react";

const selectedImage = '/assets/img/selected.png'
const unselectedImage = '/assets/img/unselected.png'

const ImageRadioButton = ({ options, name, selectedValue, onChange }) => {
  return (
    <div className="flex gap-4">
      {options.map((option) => (
        <label
          key={option.value}
          className="flex items-center gap-2 cursor-pointer"
        >
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={selectedValue === option.value}
            onChange={() => onChange(option.value)}
            className="hidden"
          />
          <img
            src={
              selectedValue === option.value
                ? selectedImage
                :unselectedImage
            }
            alt={option.label}
            className="w-6 h-6"
          />
          <span className="font-atkinson text-[14px] text-[#1B1B1B]">{option.label}</span>
        </label>
      ))}
    </div>
  );
};

export default ImageRadioButton;
